export const title = {
  success: '¡Listo!\nCreaste tu nueva contraseña.',
  error: 'Hubo un error al intentar cambiar la contraseña.'
}
